import { TKPIOption } from './kpi_dropdown/types';

export const prepareOptions = (kpis: string[]): TKPIOption[] => {
  return kpis.map((kpi) => ({
    label: kpi,
    value: kpi
  }));
};
